var scope_0 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1d349ae456495f0a8ff3580cb09e651d.js').default;
var scope_1 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/21b2266f776f776bc07c5fb1408cb420.js').default;
var scope_2 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3002c995c6115743f62728367057cce4.js').default;
var scope_3 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3440cb0e862e0f6fe4e2fbd311dbda28.js').default;
var scope_4 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3adc91770db62628a839e9856c6f892b.js').default;
var scope_5 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/41c9703c031f47b81ac488c73528875d.js').default;
var scope_6 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/49648094362529f0723ba62a90b2c2ec.js').default;
var scope_7 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/55f1dcd5c4c8ce80f482969a9a9e6233.js').default;
var scope_8 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/647393f37ee02974cdfc2b8fb76387aa.js').default;
var scope_9 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/76aa4c19256bf86bc397ad02ad6dd123.js').default;
var scope_10 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7e9168d6903f2f27173a617f318d7955.js').default;
var scope_11 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/85bc50b74e645c05675a894bb6d3ff84.js').default;
var scope_12 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a1e1d7fc233835c05802a05cc5062840.js').default;
var scope_13 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b94b5fee9012ebd9169ebe51da2a7bfb.js').default;
var scope_14 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c73aef2ab43eaccdb8ce89c5c2791779.js').default;
var scope_15 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ca503853a7c853d9e6cb1cb10addd68b.js').default;
var scope_16 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cc1fb55c26186fdb000f58f5efc67f69.js').default;
var scope_17 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/cf7166a856dbdad8430f52e7c6615920.js').default;
var scope_18 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e36b139f15539088a3d62f697515ce73.js').default;
var scope_19 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e54ec796433c5c967a22ceb1b0b63118.js').default;
var scope_20 = require('/vercel/workpath0/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fb2a841321ef48c1d358ec28e3272add.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20 )
    